<template>
  <vue-draggable-resizable
    v-if="!hideParent"
    :parent="true"
    :x="position.left"
    :y="position.top"
    :w="position.width"
    :h="position.height"
    :draggable="!isSavingLayout && !isWidgetLocked"
    :resizable="!isSavingLayout && !isWidgetLocked"
    :grid="gridScale"
    :snap="isSnapActive"
    :active="isWidgetSelected"
    :z="(isWidgetSelected && keepZIndexUp ? 1000 : 100) + widget.position[rotation].zIndex"
    :onDragStart="(x, y) => onChangePosition(true, x, y)"
    :onResizeStart="() => onChangePosition(false)"
    @dragstop="onWidgetDrag"
    @resizestop="onWidgetResize"
    @activated="() => onSelected(widget)"
    @deactivated="() => (keepZIndexUp = false)"
    @refLineParams="getRefLineParams"
  >
    <div :id="widget.object.wid" class="widget-item" :style="style">
      <iframe
        v-if="widget.object.link && widget.object.link.length !== 0 && showLayer"
        class="iframe-container"
        :style="{ height: '100%', width: '100%', zoom: scaleLayoutValue(1) }"
        :src="iframeSource"
        scrolling="no"
      />
    </div>
  </vue-draggable-resizable>
</template>

<script>
  import { duration } from 'moment';
  import VueDraggableResizable from '@/components/common/VueDraggableResizable.vue';

  import playerMixins from '@/models/player';
  import draggableWidget from '@/components/layoutDesigner/mixins/draggableWidget';

  import { simpleTypeMixin } from '@/helpers';
  import { getRBGAColor } from '@/helpers/utils';

  export default {
    name: 'LayerWidget',

    components: {
      VueDraggableResizable,
    },

    mixins: [simpleTypeMixin, playerMixins, draggableWidget],

    props: {
      widget: {
        type: Object,
      },
    },

    data() {
      return {
        showLayer: true,
        refreshTimer: null,
        refreshCount: 0,
      };
    },

    mounted() {
      if (this.refreshTimer) {
        clearInterval(this.refreshTimer);
      }

      if (
        this.widget.object.useLink &&
        !!this.widget.object.link &&
        this.widget.object.refreshTime &&
        this.widget.object.refreshTime > 0
      ) {
        const refreshInterval = duration(
          this.widget.object.refreshTime || 24,
          this.widget.object.timeUnit || 'hours',
        ).asMilliseconds();

        this.refreshTimer = setInterval(this.refreshLayer, refreshInterval);
      }
    },

    beforeDestroy() {
      if (this.refreshTimer) clearInterval(this.refreshTimer);
    },

    computed: {
      style() {
        return {
          width: '100%',
          height: '100%',
          overflow: 'hidden',
          backgroundColor: getRBGAColor(
            this.widget.object.backgroundColor,
            this.widget.object.opacity / 100,
          ),
        };
      },

      position() {
        return this.getPosition(this.widget);
      },

      iframeSource() {
        // Add refresh count as a query parameter to force iframe refresh
        const baseUrl = this.widget.object.link;
        const hasQueryParams = baseUrl.includes('?');
        const separator = hasQueryParams ? '&' : '?';

        return `${baseUrl}${separator}_refresh=${this.refreshCount}`;
      },
    },

    methods: {
      refreshLayer() {
        this.showLayer = false;
        this.refreshCount++;
        const _this = this;

        setTimeout(function () {
          _this.showLayer = true;
        }, 100);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .iframe-container {
    width: 100%;
    height: 100%;
    border: 0;
    pointer-events: none;
    overflow: hidden;
  }

  .layer-link {
    overflow: hidden;
    display: flex;
    flex-direction: column;
    text-align: center;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    color: $secondaryText;
    font-size: 32px;

    i {
      font-size: 64px;
    }
  }
</style>
